<template>
  <div class="logbo">
    <div class="container">
      <div class="header" v-if="this.girl && this.girl.menu_image_path">
        <div class="got">
          <img
            class="check"
            src="@/assets/img/loginbonus/check-mark.png"
          />&nbsp;<span class="text">本日のボーナスは獲得済みです</span>
        </div>
      </div>
      <div class="hero" @click="fireShake">
        <div class="bg">
          <div class="upper">
            <img class="background" src="@/assets/img/loginbonus/joy-bg.png" />
            <div class="joychan">
              <img
                class="body"
                :class="{ 'shake-horizontal': this.shake }"
                :src="
                  require('@/assets/img/loginbonus/joy/1125-joy-' +
                    this.joy +
                    '.png')
                "
                v-if="this.joy"
              />
            </div>
          </div>
          <img class="background" src="@/assets/img/loginbonus/table.png" />
        </div>
        <div class="caption">
          <img src="@/assets/img/loginbonus/logbo-title.png" />
          <div class="balloon" :class="{ active: this.loaded }">
            <div class="background">
              <img
                v-if="this.girl.balloon_id"
                :src="
                  require('@/assets/img/loginbonus/balloon/fukidashi-' +
                    this.balloon +
                    '01.png')
                "
              />
              <div class="speech_wrapper">
                <img
                  v-if="this.girl.balloon_id"
                  :src="
                    require('@/assets/img/loginbonus/balloon/fukidashi-' +
                      this.balloon +
                      '02.png')
                  "
                />
                <div
                  class="message font-effect-fire-animation"
                  v-html="this.girl.speech"
                ></div>
              </div>
              <img
                v-if="this.girl.balloon_id"
                :src="
                  require('@/assets/img/loginbonus/balloon/fukidashi-' +
                    this.balloon +
                    '03.png')
                "
              />
            </div>
          </div>
        </div>
        <div class="meters">
          <img
            class="menu"
            :class="{ active: this.loaded }"
            :src="girl.menu_image_path"
          />
          <img class="title" src="@/assets/img/loginbonus/meter-title.png" />
          <div class="meter">
            <div class="mask">
              <div
                class="progress"
                :style="{ width: this.progress + '%' }"
              ></div>
            </div>
            <div class="joy-progress" :style="{ left: this.progress + '%' }">
              <img
                :class="{ active: active }"
                src="@/assets/img/loginbonus/joy-icon.png"
              />
            </div>
          </div>
          <div class="prgnumber">
            <span class="number">{{ this.progress }}</span
            >/100
          </div>
          <div>
            <img
              class="logbobtn"
              src="@/assets/img/loginbonus/logbo-btn.png"
              @click.stop="link()"
            />
          </div>
        </div>
        <div class="help">
          <img
            :src="require('@/assets/img/loginbonus/question-icon.png')"
          />&nbsp;
          <router-link to="/faq/loginbonus" @click.native.stop="() => { trapTrackEvent(1) }">ヘルプ</router-link>
        </div>
      </div>
      <div class="histories">
        <h3>▼ 最近食べたもの & お知らせ ▼</h3>
        <Histories :histories="this.histories" />
      </div>

      <div class="more">
        <router-link to="/loginbonus/history" class="flex-justify-center" @click.native="() => { trapTrackEvent(2) }">
          もっと見る >
        </router-link>
      </div>
    </div>

    <!-- エラーパネル -->
    <template v-if="this.isError">
      <error-popup
        :title="this.errorTitle"
        :message="this.errorMessage"
        :label="'エラー'"
        @close="() => tapErrorClose()"
      />
    </template>
    <VersionCheck
      :show="verAlert"
      :on-close="closeAlert"
      :msg="versionErrorMsg"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DateFormatter from '../../utils/DateFormatter.js'
import moment from 'moment'
import ErrorPopup from '@/components/Modal/ErrorPopup.vue'
import Histories from './history'
import VersionCheck from '../FAQWalkVersionCheck'
import { FactoryTrack } from '@/constant/firebase'

const JOY_FILE_NAME = [
  'normal',
  'yeah',
  'joy',
  'thinking',
  'manpuku',
  'kirakira'
]

export default {
  name: 'LoginBonus',
  components: {
    ErrorPopup,
    Histories,
    VersionCheck
  },
  data: function() {
    return {
      isError: false,
      errorMessage: '',
      errorTitle: '',
      progress: 0,
      loaded: false,
      joy: '',
      active: false,
      sentence: '',
      shake: false,
      verAlert: 0,
      versionErrorMsg: ''
    }
  },
  async created() {
    document.title = 'ログインボーナス♪'
    const accTime = new DateFormatter().format(new Date())
    try {
      window.receivedToken = payload => {
        const json = JSON.parse(payload)
        this.fetchLoginBonus(json.app_token, accTime, json.user_id)
        window.receivedToken = null
      }
      this.actionRequestToken({
        apiType: '3',
        acc_time: accTime
      })
    } catch (e) {
      console.log(e)
    }
  },
  mounted: function() {},
  beforeDestroy() {},
  computed: {
    ...mapGetters({
      histories: 'LoginBonus/histories',
      girl: 'LoginBonus/girl'
    }),
    balloon: function() {
      if (!this.girl) {
        return null
      }
      return this.girl.balloon_id === 1 ? 'y' : 'p'
    }
  },
  watch: {},
  methods: {
    ...mapActions('LoginBonus', ['actionFetchLoginBonus']),
    ...mapActions('Native', [
      'actionRequestToken',
      'actionRequestExternalLink',
      'actionVer4_1'
    ]),
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Analytics', ['trackEvent']),
    moment,
    trapTrackEvent(id) {
      switch (id) {
        case 1:
          this.trackEvent(FactoryTrack.createFAQLoginBonus())
          break
        case 2:
          this.trackEvent(FactoryTrack.createLoginbonusHistory())
          break
      }
    },
    fireShake() {
      this.trackEvent(FactoryTrack.createJoychan())
      this.shake = false
      const $this = this
      setTimeout(() => {
        $this.shake = true
      }, 50)
    },
    async link() {
      this.trackEvent(FactoryTrack.createMenu())
      this.verAlert = await this.actionVer4_1()
      this.versionErrorMsg =
        'このボタンはアプリバージョン4.1.0以上対応です。<br />最新版のアプリにアップデートしてください。'
      if (this.verAlert === 0) {
        this.actionRequestExternalLink('frbbscreen://menu')
      }
      return false
    },
    closeAlert: function() {
      this.trackEvent(FactoryTrack.createVersionCheckClose())
      this.verAlert = 0
    },
    async fetchLoginBonus(token, accTime, userId, steps) {
      try {
        this.actionToggleLoading(true)

        await this.actionFetchLoginBonus({
          token,
          accTime,
          userId
        })

        const joyId = this.girl.joy_id - 1

        this.joy = JOY_FILE_NAME[joyId]

        this.loaded = true

        const $this = this
        setTimeout(() => {
          const countUp = () => {
            if ($this.girl.meter > $this.progress) {
              $this.progress += 1
              window.requestAnimationFrame(countUp)
            } else {
              this.active = true
              // const text = this.girl.speech.split('')
              // const speech = () => {
              //   if (text.length === 0) {
              //     return
              //   }
              //   this.sentence += text.shift()
              //   window.requestAnimationFrame(speech)
              // }
              // setTimeout(speech, 1000)
            }
          }
          countUp()
        }, 1000)
      } catch (e) {
        this.errorMessage = e.message
        this.errorTitle = 'エラー' + e.code
        this.isError = true
        console.error(e)
      }
      this.actionToggleLoading(false)
    },
    tapErrorClose() {
      this.trackEvent(FactoryTrack.createErrorClose())
    }
  }
}
</script>

<style lang="scss" scoped>
.logbo {
  display: flex;
}
.container {
  width: 100%;
  color: #333333;
  .header {
    font-size: 3vw;
    .got {
      background-color: #e03535;
      display: flex;
      justify-content: center;
      align-items: center;
      .check {
        width: 5vw;
      }
      .text {
        color: white;
        font-size: 4vw;
        font-weight: 900;
      }
      padding: 10px;
    }
  }

  .hero {
    position: relative;
    display: flex;
    .bg {
      width: 100%;
      .background {
        width: 100%;
      }
      .upper {
        position: relative;
        img.background {
          vertical-align: bottom;
        }
        .joychan {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          .body {
            width: 100%;
            vertical-align: bottom;
          }
        }
      }
    }
    .joy {
      position: absolute;
      width: 100%;
      top: 50%;
    }
    .caption {
      position: absolute;
      width: 100%;
      top: 0;
      padding: 10px 5px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 90%;
      }
      .balloon {
        opacity: 0;
        margin-top: 20px;
        width: 95%;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 80%;
        position: relative;
        .speech_wrapper {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          .message {
            width: 100%;
            position: absolute;
            font-weight: bold;
            font-size: 5vw;
            font-family: 'M PLUS Rounded 1c';
            padding: 0 10px;
            color: #66160E;
          }
        }
        img {
          width: 100%;
          vertical-align: bottom;
        }
        &.active {
          animation-name: balloonframe;
          animation-duration: 5s;
          animation-delay: 2s;
          /* animation-direction: alternate;
        animation-timing-function: linear;
        animation-iteration-count: infinite; */
          animation-fill-mode: forwards;
        }
      }
    }
    .meters {
      /* pointer-events: none; */
      position: absolute;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      bottom: 0;
      .menu {
        width: 100%;
        opacity: 0;
        &.active {
          animation-name: menuframe;
          animation-duration: 1s;
          animation-delay: 1s;
          animation-fill-mode: forwards;
          animation-timing-function: ease-out;
        }
      }
      .title {
        width: 60%;
        padding: 10px 0;
      }
      .meter {
        position: relative;
        width: 80%;
        height: 30px;
        .mask {
          width: 100%;
          height: 100%;

          border-radius: 5px;
          background-color: white;
          overflow: hidden;
          .progress {
            height: 100%;
            background-color: #f16063;
          }
        }
        .joy-progress {
          position: absolute;
          top: 0;
          left: 50%;
          height: 100%;
          img {
            height: 100%;
            transform: translateX(-50%) scale(1.2);

            &.active {
              animation-name: joyprogress;
              animation-duration: 1s;
              animation-direction: alternate;
              animation-timing-function: linear;
              animation-iteration-count: infinite;
            }
          }
        }
      }
      .prgnumber {
        width: 80%;
        text-align: right;
        font-size: 4vw;
        font-weight: bold;
        margin: 2px 0;
        color: #66160E;
        .number {
          color: #f16063;
        }
      }
      .logbobtn {
        margin-bottom: 10px;
        width: 50%;
        z-index: 10;
      }
    }
    .help {
      position: absolute;
      right: 20px;
      bottom: 10px;
      font-weight: bold;
      font-size: 3vw;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 4vw;
        height: 4vw;
      }

      a {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 3vw;
        color: #333333;
      }
    }
  }

  .histories {
    margin-top: -3px;
    h3 {
      color: white;
      background-color: #f16063;
      font-size: 4vw;
      padding: 10px;
    }
  }
  .more {
    color: #82523b;
    background: #fef6e7;
    font-weight: bold;
    padding: 30px 10px;
    a {
      color: #66160E;
      text-decoration: none;
    }
  }
}
@keyframes joyprogress {
  0% {
    transform: translateX(-45%) scale(1.2);
  }
  50% {
    transform: translateX(-50%) scale(1.2);
  }
  100% {
    transform: translateX(-55%) scale(1.2);
  }
}
@keyframes balloonframe {
  0% {
    transform: scale(0.7);
    opacity: 0.7;
  }
  5% {
    transform: scale(1);
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes menuframe {
  /* 0% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.75;
  }
  75% {
    transform: scale(0.8, 1.2);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  } */
  0% {
    transform: matrix3d(0.5, 0, 0, 0, 0, 0.5, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    opacity: 0.7;
  }
  3.4% {
    transform: matrix3d(0.658, 0, 0, 0, 0, 0.703, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  4.7% {
    transform: matrix3d(0.725, 0, 0, 0, 0, 0.8, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  6.81% {
    transform: matrix3d(0.83, 0, 0, 0, 0, 0.946, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  9.41% {
    transform: matrix3d(0.942, 0, 0, 0, 0, 1.084, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  10.21% {
    transform: matrix3d(0.971, 0, 0, 0, 0, 1.113, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  13.61% {
    transform: matrix3d(1.062, 0, 0, 0, 0, 1.166, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  14.11% {
    transform: matrix3d(1.07, 0, 0, 0, 0, 1.165, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  17.52% {
    transform: matrix3d(1.104, 0, 0, 0, 0, 1.12, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  18.72% {
    transform: matrix3d(1.106, 0, 0, 0, 0, 1.094, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  21.32% {
    transform: matrix3d(1.098, 0, 0, 0, 0, 1.035, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  24.32% {
    transform: matrix3d(1.075, 0, 0, 0, 0, 0.98, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  25.23% {
    transform: matrix3d(1.067, 0, 0, 0, 0, 0.969, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  29.03% {
    transform: matrix3d(1.031, 0, 0, 0, 0, 0.948, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  29.93% {
    transform: matrix3d(1.024, 0, 0, 0, 0, 0.949, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    opacity: 1;
  }
  35.54% {
    transform: matrix3d(0.99, 0, 0, 0, 0, 0.981, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  36.74% {
    transform: matrix3d(0.986, 0, 0, 0, 0, 0.989, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  41.04% {
    transform: matrix3d(0.98, 0, 0, 0, 0, 1.011, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  44.44% {
    transform: matrix3d(0.983, 0, 0, 0, 0, 1.016, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  52.15% {
    transform: matrix3d(0.996, 0, 0, 0, 0, 1.003, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  59.86% {
    transform: matrix3d(1.003, 0, 0, 0, 0, 0.995, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  63.26% {
    transform: matrix3d(1.004, 0, 0, 0, 0, 0.996, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  75.28% {
    transform: matrix3d(1.001, 0, 0, 0, 0, 1.002, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  85.49% {
    transform: matrix3d(0.999, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  90.69% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  100% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    opacity: 1;
  }
}

.shake-bottom {
  animation: shake-bottom 0.8s cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
}
@keyframes shake-bottom {
  0%,
  100% {
    transform: rotate(0deg);
    transform-origin: 50% 100%;
  }
  10% {
    transform: rotate(2deg);
  }
  20%,
  40%,
  60% {
    transform: rotate(-4deg);
  }
  30%,
  50%,
  70% {
    transform: rotate(4deg);
  }
  80% {
    transform: rotate(-2deg);
  }
  90% {
    transform: rotate(2deg);
  }
}
.shake-horizontal {
  animation: shake-horizontal 1s cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
}
@keyframes shake-horizontal {
  0%,
  100% {
    transform: translateX(0);
  }
  10%,
  30%,
  50%,
  70% {
    transform: translateX(-10px);
  }
  20%,
  40%,
  60% {
    transform: translateX(10px);
  }
  80% {
    transform: translateX(8px);
  }
  90% {
    transform: translateX(-8px);
  }
}
</style>
